<div class="autocomplete">
  <p-autoComplete
    [showClear]="showClear()"
    [showEmptyMessage]="true"
    [placeholder]="placeholder()"
    [suggestions]="suggestions"
    [optionLabel]="optionLabel()"
    (completeMethod)="completeMethod($event)"
    (onSelect)="select($event)">
    <ng-template #empty>
      <span class="p-autocomplete-empty-message">No results found</span>
    </ng-template>
  </p-autoComplete>
  <span class="search-icon material-symbols-outlined text-blue-600">
    search
  </span>
</div>
